(() => {
  const existing = window.SopapetsCollectionV5AutoFill;
  if (existing) {
    existing.hydrate(document);
    return;
  }

  const rootSelector = '[data-spv5-auto-fill]';
  const productSelector = ':scope > [data-spv5-product-index]';
  const editorialSelector = ':scope > [data-spv5-editorial]';
  const instances = new WeakMap();

  const getColumnCount = (grid) => {
    const tracks = window.getComputedStyle(grid).gridTemplateColumns.trim();
    return tracks ? tracks.split(/\s+/).length : 1;
  };

  const getEditorialSpan = (item, columns) => {
    if (window.getComputedStyle(item).display === 'none') return 0;

    const style = window.getComputedStyle(item);
    const declaration = `${style.gridColumnStart} ${style.gridColumnEnd}`;
    const span = declaration.match(/span\s+(\d+)/);

    if (style.gridColumnStart === '1' && style.gridColumnEnd === '-1') return columns;
    if (span) return Math.min(Number(span[1]), columns);
    return 1;
  };

  const buildOrder = (grid, columns) => {
    const products = [...grid.querySelectorAll(productSelector)].sort(
      (a, b) => Number(a.dataset.spv5ProductIndex) - Number(b.dataset.spv5ProductIndex)
    );
    const editorialItems = [...grid.querySelectorAll(editorialSelector)].sort(
      (a, b) => Number(a.dataset.spv5BlockOrder) - Number(b.dataset.spv5BlockOrder)
    );
    const pending = [];
    const ordered = [];
    let occupied = 0;

    const placePending = () => {
      while (pending.length > 0) {
        const item = pending[0];
        const span = getEditorialSpan(item, columns);

        if (span === 0) {
          ordered.push(pending.shift());
          continue;
        }

        const remaining = occupied === 0 ? columns : columns - occupied;
        if (span > remaining) break;

        ordered.push(pending.shift());
        occupied = (occupied + span) % columns;
      }
    };

    for (const product of products) {
      ordered.push(product);
      occupied = (occupied + 1) % columns;

      const productIndex = Number(product.dataset.spv5ProductIndex);
      for (const item of editorialItems) {
        if (Number(item.dataset.spv5InsertAfter) === productIndex) pending.push(item);
      }

      placePending();
    }

    ordered.push(...pending);
    return ordered;
  };

  const layout = (root) => {
    const grid = root.querySelector('.spv4-product-grid');
    if (!grid) return;

    const columns = getColumnCount(grid);
    const current = [...grid.children];
    const ordered = buildOrder(grid, columns);
    const hasChanged = ordered.length === current.length && ordered.some((item, index) => item !== current[index]);

    if (hasChanged) grid.append(...ordered);
    root.dataset.spv5LayoutColumns = String(columns);
  };

  const hydrateRoot = (root) => {
    const current = instances.get(root);
    if (current) {
      current.schedule();
      return;
    }

    let frame = 0;
    const schedule = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => layout(root));
    };
    const mutationObserver = new MutationObserver(schedule);
    mutationObserver.observe(root, { childList: true, subtree: true });

    const resizeObserver = new ResizeObserver(schedule);
    resizeObserver.observe(root);

    instances.set(root, { schedule, mutationObserver, resizeObserver });
    schedule();
  };

  const hydrate = (scope = document) => {
    if (scope.matches?.(rootSelector)) hydrateRoot(scope);
    for (const root of scope.querySelectorAll?.(rootSelector) ?? []) hydrateRoot(root);
  };

  window.SopapetsCollectionV5AutoFill = { hydrate };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hydrate(), { once: true });
  } else {
    hydrate();
  }

  document.addEventListener('shopify:section:load', (event) => hydrate(event.target));
})();
